import React, {useState} from 'react';
import {motion} from 'framer-motion';
import {characters} from '../data/siteData';
import CharacterModal from './CharacterModal';
import '../characters.css';

export default function CharactersSection() {
  const [selected, setSelected] = useState(null);

  return (
    <section className="section characters-section" id="characters">
      <div className="section-heading centered">
        <p className="eyebrow">The people of Magnolia</p>
        <h2>Claimed, unclaimed, and <em>fighting for home</em></h2>
      </div>
      <div className="character-grid">
        {characters.map((character, index) => (
          <motion.article
            className="character-card"
            key={character.name}
            style={{cursor: 'pointer'}}
            tabIndex={0}
            role="button"
            aria-label={`View ${character.name}`}
            onClick={() => setSelected(character)}
            onKeyDown={(e) => e.key === 'Enter' && setSelected(character)}
            initial={{opacity: 0, scale: 0.96}}
            whileInView={{opacity: 1, scale: 1}}
            viewport={{once: true}}
            transition={{duration: 0.6, delay: (index % 4) * 0.12}}
          >
            {character.image ? (
              <img src={character.image} alt={character.name} />
            ) : (
              <div className="character-placeholder" aria-hidden="true">
                <span>{character.name.charAt(0)}</span>
              </div>
            )}
            <div className="character-overlay">
              <p>{character.symbol}</p>
              <h3>{character.name}</h3>
              <span>{character.role}</span>
              <div className="character-detail">{character.description}</div>
            </div>
          </motion.article>
        ))}
      </div>
      <CharacterModal character={selected} onClose={() => setSelected(null)} />
    </section>
  );
}
